import { DARK_BLUE } from 'shared/consts';
import { TColorSlot } from 'shared/types/stylesTypes';
import { styled, css } from 'styled-components';

interface Button {
	$isOpen: boolean;
	$isSelected: boolean;
	$color?: TColorSlot;
}

export const Button = styled.button<Button>`
	background: ${props => props.$color};
	color: ${DARK_BLUE};
	height: 22px;
	width: 22px;
	border-radius: 100%;
	padding: 4px 8px;
	font-size: 12px;
	font-weight: 700;
	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;

	display: flex;
	justify-content: center;
	align-items: center;

	${props =>
		props.$isOpen &&
		css`
			width: auto;
			border-radius: 12px;
			background: ${props.$isSelected ? props.$color : 'transparent'};
			height: ${props.$isSelected ? '27px' : '22px'};
			border: 2px solid ${props.$color};
		`}
`;
